import { adminTranslations } from './admin';
import { cashierTranslations } from './cashier';
import { commonTranslations } from './common';

export const translations = {
    en: {
        admin: adminTranslations.en,
        cashier: cashierTranslations.en,
        common: commonTranslations.en.common,
        categories: {
            create: 'Create Category',
            createDesc: 'Add a new category to your menu',
            nameEnglish: 'Name (English)',
            nameArabic: 'Name (Arabic)',
            icon: 'Category Icon',
            sortOrder: 'Sort Order'
        },
        messages: {
            categoryCreated: 'Category created successfully',
            checkFormErrors: 'Please check the form for errors',
            errorOccurred: 'An error occurred while creating the category'
        }
    },
    ar: {
        admin: adminTranslations.ar,
        cashier: cashierTranslations.ar,
        common: commonTranslations.ar.common,
        categories: {
            create: 'إضافة فئة',
            createDesc: 'إضافة فئة جديدة إلى القائمة',
            nameEnglish: 'الاسم (بالإنجليزية)',
            nameArabic: 'الاسم (بالعربية)',
            icon: 'أيقونة الفئة',
            sortOrder: 'ترتيب الفرز'
        },
        messages: {
            categoryCreated: 'تم إنشاء الفئة بنجاح',
            checkFormErrors: 'يرجى التحقق من الأخطاء في النموذج',
            errorOccurred: 'حدث خطأ أثناء إنشاء الفئة'
        }
    }
};
